// Purpose: Product model API calls
// Caller: productModelAction, SyncProductModal, ProductModal
// Dependencies: utils/xhr
// Main Functions: getProductModels, createProductModel, updateProductModel, deleteProductModel, getProductModelOptions
// Side Effects: HTTP CRUD /product-model, HTTP GET /product-model/options

import { xhr } from 'utils'

export const getProductModels = (params = '') => xhr.get(`/product-model?${params}`)
export const createProductModel = (data) => xhr.post('/product-model', data)
export const updateProductModel = (data, id) => xhr.put(`/product-model/${id}`, data)
export const deleteProductModel = (id) => xhr.delete(`/product-model/${id}`)
export const getProductModelOptions = () => xhr.get('/product-model/options')
